import { useState, useEffect } from 'react';
import { HylideBridge } from 'api/HylideBridgeTypes';
import 'https://cdn.marmot-cloud.com/npm/hylid-bridge/2.10.0/index.js';

/** Reads the bridge the CDN script installs on `window`, or `null` on a host that has none. */
const readBridge = (): HylideBridge | null => (window as any).my ?? null;

const useHylideBridge = (): HylideBridge | null => {
  // Initialized lazily rather than to `null`: the bridge script is a static import, so the global
  // already exists by first render on a host that has it. Returning `null` for one render made
  // callers momentarily believe the host had no bridge — enough for UI keyed on its availability
  // to flicker. The effect stays as a safety net for a script that installs itself late.
  const [hylideBridge, setHylideBridge] = useState<HylideBridge | null>(readBridge);

  useEffect(() => {
    setHylideBridge(readBridge());
  }, []);

  return hylideBridge;
};

export default useHylideBridge;
